module.exports = __webpack_public_path__ + "img/chat.2ae27e37.svg";